<template>
  <div class='lead-info__item'>
    <div class='lead-info__label'>{{ name }}</div>
    <div class='lead-info__actions'>
      <span class='font-weight-medium'>
        {{ value }}
      </span>

      <v-dialog v-model='isOpened' width='500'>
        <template v-slot:activator='{ on, attrs }'>
          <v-btn v-bind='attrs' v-on='on' text icon>
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>

        <v-card>
          <v-card-title class='text-h5 grey lighten-2'>
            Edit {{ name }}
          </v-card-title>

          <div class='modal-body'>
            <v-text-field
              v-model='editableValue'
              class='edit-modal__input'
              :label='name'
              :error='$v.editableValue.$error'
              v-mask="'##-##-####'"
              placeholder='mm-dd-yyyy'
            />
          </div>

          <v-divider />

          <v-card-actions>
            <v-spacer />
            <v-btn color='primary' text @click='isOpened = false'>
              Cancel
            </v-btn>
            <v-btn color='info' text @click='onSubmit' :errors='$v.$error'>
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'PlateDatepickerForm',
  props: {
    name: String,
    value: [String, Number],
    field: String,
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.$emit('update', this.editableValue);

      this.isOpened = false;
      this.editableValue = null;
    },
  },
  watch: {
    isOpened() {
      if (this.isOpened) {
        this.editableValue = this.value;
      }
    },
  },
  data() {
    return {
      isOpened: false,
      editableValue: null,
    };
  },
  validations: {
    editableValue: {
      required,
    },
  },
};
</script>

<style lang='scss' scoped>
.modal-body {
  padding: 15px 20px 10px;
}

.edit-modal__input {
  .v-text-field__details {
    display: none;
  }
}

.lead-info {
  &__item {
    display: flex;
    align-items: center;
    gap: 25px;
  }

  &__actions {
    display: flex;
    align-items: center;
    gap: 15px;
  }
}
</style>
